import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Home from './home';
import User from './view/user';
import Filiais from './view/filiais';
import Produtos from './view/produtos';
import Entradas from './view/entrada';
import Ctrl from './view/ctrl';
import CtrlSaida from './view/ctrlSaida';
import CtrlEntrada_OT from './view/ctrlEntrada_OT';
import Log from './view/log';
import Pedidos from './view/pedidos';

import TabelaPrecos from './view/omieTabelaPrecos';

import TabelaPrecosExec from './view/omieTabelaPrecosExec';

import { AppSidebar, AppFooter, AppHeader } from '../index';

export default function Users() {
  let match = useRouteMatch();

  return (
    <main>
      <div>
        <AppSidebar />
        <div className="wrapper d-flex flex-column min-vh-100 bg-light">
          <AppHeader />
          <div className="body flex-grow-1 px-3">
            <Switch>
              <Route exact path={[`${match.path}/home`, `${match.path}`]} component={Home} />
              <Route path={`${match.path}/user`} component={User} />
              <Route path={`${match.path}/filiais`} component={Filiais} />
              <Route path={`${match.path}/produtos`} component={Produtos} />
              <Route path={`${match.path}/entrada`} component={Entradas} />
              <Route path={`${match.path}/ctrl`} component={Ctrl} />
              <Route path={`${match.path}/ctrlSaida`} component={CtrlSaida} />
              <Route path={`${match.path}/ctrlEntrada_OT`} component={CtrlEntrada_OT} />
              <Route path={`${match.path}/log`} component={Log} />
              <Route path={`${match.path}/pedidos`} component={Pedidos} />
              <Route path={`${match.path}/omieTabelaPrecos`} component={TabelaPrecos} />
              <Route path={`${match.path}/omieTabelaPrecosExec`} component={TabelaPrecosExec} />
            </Switch>
          </div>
          <AppFooter />
        </div>
      </div>
    </main>
  );
}


